import React from "react";
import { PlayerCountDistributionChart } from "./Chart";
import { SinglePageView } from "../core/ListView";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { useGamePlayTests } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const PlayerCountDistribution = ({ gameId }) => {
  const { data: playTests = [] } = useGamePlayTests(gameId);

  const playTestsWithPlayers = playTests.filter((pt) => pt.ignore && pt.outcomes.length > 0);
  const incompletePlayTests = playTests.filter((pt) => pt.ignore && pt.outcomes.length === 0);

  return (
    <SinglePageView title={`Play Tests by Player Count`}>
      {playTestsWithPlayers.length === 0 ? (
        <Box p={1}>
          <Alert severity="warning">
            To use this chart you need to record players for your play tests. Update your play tests to include player
            information.
          </Alert>
        </Box>
      ) : (
        <Box p={1}>
          <Alert severity="info">
            This chart shows the distribution of play tests by number of players. Only play tests with recorded players
            are included.
            {incompletePlayTests.length > 0 && (
              <>
                {" "}
                There are {incompletePlayTests.length} play test{incompletePlayTests.length === 1 ? "" : "s"} without
                player data.
              </>
            )}
          </Alert>
        </Box>
      )}
      <PlayerCountDistributionChart gameId={gameId} />
    </SinglePageView>
  );
};
